/* src/app/components/help/help.component.css */
.help-lede {
  color: var(--fg-2);
  font-size: var(--text-sm);
  max-width: 70ch;
  margin-bottom: var(--space-4);
}
.help-search {
  position: relative;
  max-width: 520px;
  margin-bottom: var(--space-3);
}
.help-search .form-control {
  padding-left: 36px;
  padding-right: 88px;
}
.help-search-icon {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--fg-4);
  pointer-events: none;
}
.help-search-clear {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: var(--text-xs);
  text-decoration: none;
}
.help-count {
  color: var(--fg-3);
  font-size: var(--text-xs);
  margin-bottom: var(--space-4);
}
.help-empty {
  border: 1px dashed var(--border);
  border-radius: var(--radius-md);
  padding: var(--space-6);
  text-align: center;
  color: var(--fg-3);
  font-size: var(--text-sm);
}
.help-section {
  margin-top: var(--space-6);
}
.help-section-title {
  font-size: var(--text-xs);
  font-weight: var(--weight-semibold);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--fg-3);
  padding-bottom: var(--space-2);
  border-bottom: 1px solid var(--border);
  margin-bottom: var(--space-4);
}
.help-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--space-4);
}
.help-card {
  scroll-margin-top: 96px;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.help-card-head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
.help-card-icon {
  color: var(--navy-600);
  flex-shrink: 0;
}
.help-card-title {
  margin: 0;
  font-size: var(--text-base);
  font-weight: var(--weight-semibold);
  color: var(--fg-1);
}
.help-card-body {
  margin: 0;
  color: var(--fg-2);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}
.help-legacy {
  color: var(--fg-2);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
  max-width: 80ch;
}
.help-legacy a {
  color: var(--navy-600);
}
.help-card:target {
  border-color: var(--navy-600);
  box-shadow: 0 0 0 1px var(--navy-600);
}
/*# sourceMappingURL=help.component.css.map */
